const LayoutSiderInjectionKey = Symbol("LayoutSiderInjectionKey");
const SiderInjectionKey = Symbol("SiderInjectionKey");
export { LayoutSiderInjectionKey, SiderInjectionKey };
